module.exports = __webpack_public_path__ + "img/allottee3_7-8-2021.d46675d3.jpg";